import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const menuItems = [
  { label: 'Accueil', path: '/' },
  { label: 'Espaces intérieurs', path: '/interiors' },
  { label: 'Espaces extérieurs', path: '/exteriors' },
  { label: 'Création sur mesure', path: '/creations-sur-mesure' },
  { label: 'À propos', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

const logoUrl =
  'https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/a6bd3919-f5da-42c7-bbed-5fa948e855d4_compressed_logo-RD-V2.webp';

export default function SiteHeader() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  // Ferme le menu à chaque changement de page
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Bloque le scroll du body quand le menu latéral est ouvert
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <>
      {/* En-tête : logo à gauche + burger à droite (mobile) */}
      <header className="p-6 md:p-10 flex items-center justify-between">
        <Link to="/" className="md:hidden">
          <img
            src={logoUrl}
            alt="Romuald Roudart"
            className="w-14 h-14 md:w-16 md:h-16 object-contain cursor-pointer"
          />
        </Link>

        {/* Bouton burger — visible uniquement sur mobile */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          aria-label="Ouvrir le menu"
          aria-expanded={open}
        >
          <div className="relative w-6 h-5 flex flex-col justify-between items-center">
            <span
              className={`block w-6 h-px bg-current transition-all duration-300 origin-center ${
                open ? 'rotate-45 translate-y-[9px]' : ''
              }`}
            />
            <span
              className={`block w-6 h-px bg-current transition-all duration-300 ${
                open ? 'opacity-0 scale-x-0' : ''
              }`}
            />
            <span
              className={`block w-6 h-px bg-current transition-all duration-300 origin-center ${
                open ? '-rotate-45 -translate-y-[9px]' : ''
              }`}
            />
          </div>
        </button>
      </header>

      {/* Menu centré — desktop uniquement */}
      <nav className="hidden md:flex justify-center px-6 -mt-2 mb-6">
        <div className="flex overflow-hidden items-center">
          <Link
            to="/"
            className="flex items-center px-2 md:px-3 py-2.5 border-r border-white/20 text-white hover:bg-white/10 cursor-pointer"
          >
            <img
              src={logoUrl}
              alt="Romuald Roudart"
              className="w-14 h-14 object-contain"
            />
          </Link>

          {menuItems.map((item, idx) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.label}
                to={item.path}
                className={`px-4 md:px-6 py-2.5 text-sm md:text-base tracking-wide whitespace-nowrap transition-colors cursor-pointer ${
                  isActive ? 'bg-white text-black' : 'text-white hover:bg-white/10'
                } ${idx !== menuItems.length - 1 ? 'border-r border-white/20' : ''}`}
              >
                {item.label}
              </Link>
            );
          })}
        </div>
      </nav>

      {/* Voile sombre — mobile */}
      <div
        className={`md:hidden fixed inset-0 z-40 bg-black/60 backdrop-blur-sm transition-opacity duration-300 ${
          open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setOpen(false)}
        aria-hidden="true"
      />

      {/* Panneau latéral — mobile */}
      <div
        className={`md:hidden fixed top-0 right-0 bottom-0 z-50 w-72 max-w-[80vw] bg-black border-l border-white/15 transition-transform duration-500 ease-out ${
          open ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full pt-8 px-8 pb-8">
          <div className="flex items-center justify-between mb-10">
            <img src={logoUrl} alt="Romuald Roudart" className="w-12 h-12 object-contain" />
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="w-10 h-10 flex items-center justify-center text-white cursor-pointer"
              aria-label="Fermer le menu"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
          </div>

          <nav className="flex flex-col gap-6">
            {menuItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.label}
                  to={item.path}
                  onClick={() => setOpen(false)}
                  className={`text-lg tracking-wide whitespace-nowrap cursor-pointer transition-colors ${
                    isActive ? 'text-white border-l-2 border-white pl-3' : 'text-white/70 hover:text-white pl-3'
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </>
  );
}